module.exports = __webpack_public_path__ + "img/banner.8be78144.jpg";